import { render, staticRenderFns } from "./ativos.vue?vue&type=template&id=6a85bdfd"
import script from "./ativos.vue?vue&type=script&lang=js"
export * from "./ativos.vue?vue&type=script&lang=js"
import style0 from "./ativos.vue?vue&type=style&index=0&id=6a85bdfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports